import { processLabels } from '@/components/InvoiceReportDetailDrawer/ApplicationContent/helper';
import type { FormInputItem } from '@/components/InvoiceReportDetailDrawer/ApplicationContent/types';
import { Flex } from 'antd';
import { FC, memo, useMemo } from 'react';

type CombineLabelFieldViewProps = {
  item: FormInputItem;
};

export const CombineLabelFieldView: FC<CombineLabelFieldViewProps> = memo(
  ({ item }) => {
    const processedLabels = useMemo(() => {
      return processLabels(item?.input_values || []);
    }, [item?.input_values]);

    if (processedLabels.length === 0) {
      return null;
    }

    return (
      <Flex>
        {processedLabels?.map(({ id, label }) => (
          <div key={id ?? 'empty-view-combine-label-field'}>{label ?? ''}</div>
        ))}
      </Flex>
    );
  }
);

CombineLabelFieldView.displayName = 'CombineLabelFieldView';
